import * as L from 'leaflet';
import * as esri from 'esri-leaflet';

import { TileLayer } from './tileLayer';

export type EsriBaseMapsOverride = esri.Basemaps | 'ImageryFirefly' | 'Physical';

export class EsriBaseLayer extends TileLayer {
  public esriBasemapType: EsriBaseMapsOverride;

  constructor(id: string, name?: string) {
    super(id, name);
  }

  public getLeafletLayer(): Promise<L.Layer> {
    return Promise.resolve(esri.basemapLayer(this.esriBasemapType as esri.Basemaps, this.options.getAll()));
  }

  public setEsriType(esriBasemapType: EsriBaseMapsOverride): this {
    this.esriBasemapType = esriBasemapType;
    return this;
  }
}
